import { ErrorType } from '@error-util-lib/error.model'
import { EntityState } from '@ngrx/entity'
import {
    MAX_NOTIFICATION_CHUNK_SIZE,
    Notification,
    NotificationFilterValues,
    NotificationsActionRequest,
    NotificationUseCase,
} from '@platform-lib/notification/notification.model'
import { notificationEntryAdapter } from './notification.adapter'

export const notificationFeatureKey = 'notification'

type NotificationEntryState = EntityState<Notification>

export type NotificationState = Readonly<{
    count: number
    overlayEntries: NotificationEntryState
    overlayEntriesLimit: number
    overlayEntriesLoading: boolean
    overlayEntriesLoadingError: ErrorType | null
    allRead: boolean
    pageEntries: NotificationEntryState
    pageEntriesAvailable: boolean
    pageLoading: boolean
    pageLoadingError: ErrorType | null
    pageChunkSize: number
    pageEntriesLoaded: number
    selectableUseCases: NotificationUseCase[]
    filterValues: NotificationFilterValues
    removeEntriesParams: NotificationsActionRequest | null
    setAllAsReadLoading: boolean
}>

export const initialNotificationState: NotificationState = {
    count: 0,
    overlayEntries: notificationEntryAdapter.getInitialState(),
    pageEntriesAvailable: true,
    overlayEntriesLimit: 15,
    overlayEntriesLoading: false,
    overlayEntriesLoadingError: null,
    allRead: false,
    pageEntries: notificationEntryAdapter.getInitialState(),
    pageLoading: false,
    pageLoadingError: null,
    pageChunkSize: MAX_NOTIFICATION_CHUNK_SIZE,
    pageEntriesLoaded: 0,
    selectableUseCases: [],
    filterValues: {
        priorities: [],
        useCases: [],
    },
    removeEntriesParams: null,
    setAllAsReadLoading: false,
}
